var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500", lazy: "" },
          model: {
            value: _vm.showInfoDialog,
            callback: function($$v) {
              _vm.showInfoDialog = $$v
            },
            expression: "showInfoDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { attrs: { "primary-title": "" } }, [
                _c("div", [
                  _c("p", [
                    _vm._v(
                      "\n            Automatically create load groups from this Repeat Load as per the schedule here.\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n            Loads scheduled here are added to the planner early Friday morning for the following week.\n          "
                    )
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500", lazy: "" },
          model: {
            value: _vm.showSchedulerDialog,
            callback: function($$v) {
              _vm.showSchedulerDialog = $$v
            },
            expression: "showSchedulerDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { attrs: { "primary-title": "" } }, [
                _vm._v("\n       Add schedule\n      ")
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              label: "Time",
                              type: "time",
                              "error-messages": _vm.errors.first("time"),
                              "data-vv-as": "Time",
                              "data-vv-name": "time"
                            },
                            model: {
                              value: _vm.dayScheduleTime,
                              callback: function($$v) {
                                _vm.dayScheduleTime = $$v
                              },
                              expression: "dayScheduleTime"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              label: "Load count",
                              type: "number",
                              "error-messages": _vm.errors.first("loadCount"),
                              "data-vv-as": "Load count",
                              "data-vv-name": "count"
                            },
                            model: {
                              value: _vm.dayScheduleTotalCount,
                              callback: function($$v) {
                                _vm.dayScheduleTotalCount = $$v
                              },
                              expression: "dayScheduleTotalCount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", disabled: _vm.errors.any() },
                      on: { click: _vm.saveSchedule }
                    },
                    [_vm._v("Save")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          return _vm.closeScheduleDialog()
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", fab: "", color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.showInfoDialog = true
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("info")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          _c("v-toolbar-title", [
                            _vm._v(
                              "\n              Auto-Scheduled Weekly Load Groups\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-sub-title",
                            { staticClass: "font-italic font-weight-light" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.loadCount) +
                                  " weekly " +
                                  _vm._s(
                                    _vm._f("pluralize")(_vm.loadCount, "load", {
                                      includeNumber: false
                                    })
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-items",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isDirty,
                              expression: "isDirty"
                            }
                          ]
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                flat: "",
                                color: "accent",
                                disabled: _vm.savingSchedule
                              },
                              on: { click: _vm.resetSchedule }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c("v-icon", [_vm._v("clear")]),
                                  _vm._v(
                                    "\n                Ignore\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                loading: _vm.savingSchedule
                              },
                              on: { click: _vm.saveScheduleUpdates }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c("v-icon", [_vm._v("save")]),
                                  _vm._v(
                                    "\n                Save\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    [
                      _vm._l(_vm.loadGroups, function(loadGroup) {
                        return [
                          _c(
                            "v-list-tile",
                            {
                              key: loadGroup.day + ".group",
                              staticClass: "list-hotfix"
                            },
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        small: "",
                                        flat: "",
                                        color: "accent"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.openScheduleDialog(
                                            loadGroup.day
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("add")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-tile-title", [
                                _c("b", [_vm._v(_vm._s(loadGroup.day))])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(loadGroup.details, function(detail, dayIdx) {
                            return _c(
                              "v-list-tile",
                              {
                                key: loadGroup.day + "_" + dayIdx + "_day",
                                staticClass: "pl-4"
                              },
                              [
                                _c(
                                  "v-list-tile-action",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          fab: "",
                                          small: "",
                                          flat: "",
                                          color: "accent"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteSchedule(
                                              loadGroup,
                                              detail
                                            )
                                          }
                                        }
                                      },
                                      [_c("v-icon", [_vm._v("delete")])],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c("v-list-tile-title", [
                                      _vm._v(
                                        "\n                 " +
                                          _vm._s(
                                            _vm._f("formatScheduleTime")(
                                              detail.scheduledPickupTime
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("v-list-tile-sub-title", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm._f(
                                              "pluralize"
                                            )(detail.loadCount, "truck", {
                                              includeNumber: true
                                            })
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c("v-divider", { key: loadGroup.day + "_divider" })
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b114a66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b114a66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoWidgets/ScheduleRepeatLoads.vue
// module id = null
// module chunks = 